import ProfileImage from "components/profileImage";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { CardBody } from "reactstrap";

const BlogsList = ({ blogs, handleActiveOrder }) => {
  const [activeCardId, setActiveCardId] = useState();
  const [filterdBlogs, setfilterdBlogs] = useState([]);
  const [allList, setAllList] = useState([]);
  useEffect(() => {
    setfilterdBlogs(blogs);
    setAllList(blogs)
  }, [blogs]);
  const handleActiveCard = id => {
    setActiveCardId(id);
  };
  const handleOrder = ele => {
    handleActiveOrder(ele);
  };
  const handleSearch = search => {
    if (search) {
      let tempList = _.cloneDeep(allList);
      let filterList = tempList.filter(
        ele =>
          ele?.title?.toLowerCase().includes(search.toLowerCase())
      );
      setfilterdBlogs(filterList);
    } else {
      setfilterdBlogs(allList);
    }
  };
  const RenderOrderCards = blogs => {
    if (blogs?.length === 0) {
      return (
        <CardBody role="button" className="">
          blogs are empty
        </CardBody>
      );
    }

    return (
      <>
        
        {blogs?.map((ele, indx) => {
          // console.log(order, "order");
          const FixedClass = "border border-bottom-1 order_card ";
          const activeStatusClass =
            activeCardId === ele?._id
              ? FixedClass + "bg-lightGrey"
              : FixedClass;
          return (
            <CardBody
              role="button"
              key={indx}
              className={activeStatusClass}
              onClick={() => {
                handleOrder(ele);
                handleActiveCard(ele?._id);
              }}
            >
              <div className="d-flex align-items-center buttons">
                <div>
                  <ProfileImage
                    image={ele?.mobileBanner}
                    height="50"
                    width="50"
                    classNames="avatar-sm rounded bg-light"
                  />
                </div>
                <div className="ms-3">
                  <h6>{ele?.title}</h6>
                  <div>
                    <span>Created At : </span>
                    {moment(ele?.createdAt).format("DD-MMM-YYYY @ hh:mm a")}
                  </div>
                  <div>
                    <span>Published On: </span>
                    {moment(ele?.publishedDate).format("DD-MMM-YYYY")}
                  </div>
                </div>
              </div>
            </CardBody>
          );
        })}
      </>
    );
  };
  return (
    <div>
      <CardBody className="p-0">
      <div>
          <div className="search-box m-2">
            <div className="position-relative">
              <i className="bx bx-search-alt search-icon" />
              <input
                className="form-control py-2 rounded-pill bg-white"
                type="search"
                id="example-search-input"
                placeholder=" Search..."
                onChange={event => handleSearch(event.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="tabs Orders_tabs">
          <div
            className="order-scroll"
            // ref={containerRef}
            // onScroll={handleScrollEvent}
          >
            {RenderOrderCards(filterdBlogs)}
          </div>
        </div>
      </CardBody>
    </div>
  );
};

export default BlogsList;
